"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EyeIcon;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Icon = require("./Icon");

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EyeIcon(props) {
  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement("path", { d: "M12.0190275,6 L12.019,6.001 L12.3052826,6.00551327 C15.1048368,6.10088273 17.6119141,7.42849705 19.5919662,9.59533074 C20.5063477,10.5959675 20.9753776,11.3898443 20.9990558,11.9769614 L21,12.0233463 L21,12.0233463 C20.9753776,12.6101557 20.5063477,13.4040325 19.5919662,14.4046693 C17.6119141,16.571503 15.1048368,17.8991173 12.3052826,17.9944867 L12.019,17.999 L12.0190275,18 L11.9809725,18 L11.9809725,18 L11.98,17.999 L11.6947174,17.9944867 C8.8951632,17.8991173 6.38808587,16.571503 4.40803383,14.4046693 C3.49365226,13.4040325 3.02462238,12.6101557 3.00094418,12.0230386 L3,11.9766537 L3,11.9766537 C3.02462238,11.3898443 3.49365226,10.5959675 4.40803383,9.59533074 C6.38808587,7.42849705 8.8951632,6.10088273 11.6947174,6.00551327 L11.98,6.001 L11.9809725,6 L12.0190275,6 Z M12,8 C9.790861,8 8,9.790861 8,12 C8,14.209139 9.790861,16 12,16 C14.209139,16 16,14.209139 16,12 C16,9.790861 14.209139,8 12,8 Z M12,10 C13.1045695,10 14,10.8954305 14,12 C14,13.1045695 13.1045695,14 12,14 C10.8954305,14 10,13.1045695 10,12 C10,10.8954305 10.8954305,10 12,10 Z" })
  );
}